var auth = require('basic-auth');
var compare = require('tsscmp');

export default (req, res, next) => {
    if (!process.env.BASIC_AUTH_USERNAME || !process.env.BASIC_AUTH_PASSWORD) {
        next();
        return;
    }

    // Skip authentication if visiting from Savage office
    if (req.headers['x-forwarded-for'] == '120.29.242.212') {
        next();
        return;
    }

    var credentials = auth(req);
 
    // Check credentials
    if (!credentials || !check(credentials.name, credentials.pass)) {
        res.writeHead(401, { 'WWW-Authenticate': 'Basic realm="example"' });
        res.end('Access denied');
    } else {
        next();
    }
}

function check (name, pass) {
    var valid = true;

    // Simple method to prevent short-circut and use timing-safe compare
    valid = compare(name, process.env.BASIC_AUTH_USERNAME) && valid;
    valid = compare(pass, process.env.BASIC_AUTH_PASSWORD) && valid;

    return valid;
}